import React from 'react'
import { LeaderData } from '../../../../Api'
import {
  InfoCon,
  MainPlayerCon,
  PlayerImg,
  PlayerLink,
  PlayerStatStyle,
  StatNameText,
} from '../styles'
import { mapPlayerStat } from '../../../../Utils'
import { createUrl } from '../../../../Routing/urls'
import { CURRENT_YEAR } from '../../../../Config/League/league.config'
import { colors } from '../../../../Components/consts'

type RowProps = {
  teamLeaders: LeaderData[]
  stat: string
  awayId: string
  homeId: string
}

export const PlayerRow: React.FC<React.PropsWithChildren<RowProps>> = ({
  teamLeaders,
  stat,
  awayId,
  homeId,
}) => {
  const awayLeader = teamLeaders.find(
    (leader) => leader.statType === stat && leader.teamId === awayId
  )
  const homeLeader = teamLeaders.find(
    (leader) => leader.statType === stat && leader.teamId === homeId
  )

  return (
    <>
      {(awayLeader || homeLeader) && (
        <MainPlayerCon>
          <div className="left">
            {!awayLeader ? (
              <div>No PLL Stats</div>
            ) : (
              <>
                <PlayerLink
                  href={createUrl('player', {
                    slugName: awayLeader.slug,
                    tab: 'profile',
                    year: CURRENT_YEAR,
                  })}
                  aria-label={`${awayLeader.firstName} ${awayLeader.lastName} profile`}
                >
                  <InfoCon side="left">
                    <PlayerImg src={awayLeader.profileUrl} alt="" />
                    <h2>
                      {awayLeader.firstName} {awayLeader.lastName}
                    </h2>
                    <p>{`${awayLeader.jerseyNum || ''} • ${
                      awayLeader.position || ''
                    }`}</p>
                  </InfoCon>
                </PlayerLink>
              </>
            )}
          </div>

          <div className="center">
            <PlayerStatStyle teamColor={colors.white}>
              {awayLeader && awayLeader.statValue}
            </PlayerStatStyle>
            <StatNameText>{mapPlayerStat(stat)}</StatNameText>
            <PlayerStatStyle teamColor={colors.white}>
              {homeLeader && homeLeader.statValue}
            </PlayerStatStyle>
          </div>
          <div className="right">
            {!homeLeader ? (
              <div>No PLL Stats</div>
            ) : (
              <>
                <PlayerLink
                  href={createUrl('player', {
                    slugName: homeLeader.slug,
                    tab: 'profile',
                    year: CURRENT_YEAR,
                  })}
                  aria-label={`${homeLeader.firstName} ${homeLeader.lastName} profile`}
                >
                  <InfoCon side="right">
                    <PlayerImg src={homeLeader.profileUrl} alt="" />
                    <h2>
                      {homeLeader.firstName} {homeLeader.lastName}
                    </h2>
                    <p>{`${homeLeader.jerseyNum || ''} • ${homeLeader.position}`}</p>
                  </InfoCon>
                </PlayerLink>
              </>
            )}
          </div>
        </MainPlayerCon>
      )}
    </>
  )
}
